export const validateBik = (value: string | undefined) => {
  let error = null;
  if (!value) {
    error = 'Обязательное поле';
  }
  return error;
};

export const validateAccount = (value: string | undefined) => {
  let error = null;
  if (!value) {
    error = 'Обязательное поле';
  } else if (value.length < 20) {
    error = 'Необходимо ввести 20 цифр';
  }
  return error;
};

const validate = (values: any) => {
  const errors: any = {};

  const bikError = validateBik(values.bik);
  if (bikError) {
    errors.bik = bikError;
  }

  const accountError = validateAccount(values.account);
  if (accountError) {
    errors.account = accountError;
  }

  return errors;
};

export default validate;
